import { IValidationRule } from '../../Services/FormikValidatorService';

export type ValidationParam = 'minDate' | 'maxDate' | 'required';

export type ValidationItem = {
  param: ValidationParam;
  value: unknown;
  message: string;
};

export interface RefuelingValidationApiResponse {
  accountingTs: ValidationItem[];
  amount: ValidationItem[];
  attachments: ValidationItem[];
  billId: ValidationItem[];
  currencyId: ValidationItem[];
  customerId: ValidationItem[];
  fuelTypeId: ValidationItem[];
  gasStationNetworkId: ValidationItem[];
  note: ValidationItem[];
  price: ValidationItem[];
  priceIncVat: ValidationItem[];
  rideId: ValidationItem[];
  secondaryCurrencyId: ValidationItem[];
  secondaryPrice: ValidationItem[];
  secondaryPriceIncVat: ValidationItem[];
  secondaryUnitPrice: ValidationItem[];
  secondaryUnitPriceIncVat: ValidationItem[];
  secondaryVat: ValidationItem[];
  unitPrice: ValidationItem[];
  unitPriceIncVat: ValidationItem[];
  vat: ValidationItem[];
  vatPrice: ValidationItem[];
  vehicleId: ValidationItem[];
}

export interface RefuelingsFormValues {
  accountingTs: string | Date;
  vehicleId?: string;
  rideId: string;
  gasStationNetworkId: string | null;
  fuelTypeId: string;
  amount: string;
  vat: string;
  unitPriceIncVat: string;
  unitPrice: string;
  price: string;
  vatPrice: string;
  priceIncVat: string;
  currencyId: string;
  billId: string;
  note: string;
  attachments: any[];
  mileage: string;
  refuelingAfterDistanceKm: string;
  secondaryCurrencyId?: string;
  secondaryVat?: string;
  secondaryUnitPriceIncVat?: string;
  secondaryUnitPrice?: string;
  secondaryPrice?: string;
  secondaryVatPrice?: string;
  secondaryPriceIncVat?: string;
  source?: 'can' | 'manual';
  refuelingCanId?: string;
  customerId?: number;
}

export interface RefuelingApiResponse {
  attachments: any; // Chyba v novom endpointe ???
  accountingTs: string;
  amount: number;
  billId: number | null;
  createdAt: string;
  createdBy: number;
  currencyId: number;
  customerId: number;
  fuelTypeId: number;
  gasStationNetworkId: number | null; // Chyba v novom endpointe ???
  id: number;
  mileage: number;
  modifiedAt: string | null;
  modifiedBy: number | null;
  note: string;
  price: number;
  priceIncVat: number;
  refuelingAfterDistanceKm: number; // Chyba v novom endpointe ???
  rideId: string;
  secondaryCurrencyId: number;
  secondaryPrice: number;
  secondaryPriceIncVat: number;
  secondaryUnitPrice: number;
  secondaryUnitPriceIncVat: number;
  secondaryVat: number | null;
  secondaryVatPrice: number | null;
  source: string;
  unitPrice: number;
  unitPriceIncVat: number;
  vat: number;
  vatPrice: number; // Chyba v novom endpointe ???
  vehicleId: number;
}

export interface RefuelingInput {
  indexId: string;
  type: string;
  subtype?: string;
  title: string;
  placeholder: string;
  value?: string | undefined;
  values?: {
    item: string;
    value: string;
  };
  firstDisabled: boolean;
  multiple: boolean;
  disabled: boolean;
  readonly: boolean;
  sendOnChange: boolean;
  rules: IValidationRule[];
}

interface Paging {
  currentPage: number;
  pagesTotal: number;
  rowsPerPage: number;
  rowsTotal: number;
}

interface Action {
  disabled: boolean;
  icon: string;
  id: string;
  link: string | null;
  title: string;
  type: string;
}

interface SummaryColumn {
  name: string;
  value: null | string;
}

interface Filter {
  active: boolean;
  filtered?: boolean;
  multiple?: boolean;
  placeholder?: string | null;
  required: boolean;
  selectedValue: any;
  title: string;
  type: string;
  values?: { item: string; value: any; label?: string | null; customerLabel?: string | null }[];
  maxDate?: string;
  minDate?: string;
  maxTitle?: string;
  maxValue?: number;
  minTitle?: string;
  minValue?: number;
  regex?: null | string;
  sign?: null | string;
  signPlacement?: string;
  subType?: string;
}

interface RefuelingRecord {
  actions: Action[];
  amount: string;
  anotherCurrency: string;
  assignedToRide: string;
  attachments: any[];
  averageConsumption: string;
  averageFuelConsCan: null | number;
  billId: string | null;
  createdAt: string;
  createdBy: number;
  currencyId: number;
  customerId: number;
  fuelConsCan: null | number;
  fuelLevelCan: number | null;
  fuelLevelUser: null | number;
  fuelTypeId: number;
  gasStationNetworkId: null | number;
  id: number;
  identifier: string | null;
  licenceNumber: number;
  links: { assignedToRide: string };
  locked: string;
  mileage: string;
  mileageDiffKm: string;
  modifiedAt: null | string;
  modifiedBy: null | number;
  note: string | null;
  price: string;
  priceIncVat: string;
  source: string;
  timestamp: string;
  unitPrice: string;
  unitPriceIncVat: string;
  vat: string;
  vatPrice: string;
  vehicleId: number;
  vehicleName: number;
  positionCount: number;
  rideSource: string;
}

export interface RefuelingDataApiResponse {
  paging: Paging;
  records: RefuelingRecord[];
  status: 200;
  summary: { title: string; columns: SummaryColumn[] }[];
  warning?: any;
}

interface Export {
  actionUrl: string | null;
  enabled: boolean;
  fileName: string;
  formats: string[];
}

export interface RefuelingSettingsApiResponse {
  actions: { multipleActions: Action[]; rowActions: { maxActionCountPerRow: number } };
  columns: RefuelingColumn;
  export: Export;
  sorting: { [key: string]: string }[];
  status: number;
  userSettingsKey: string;
}

interface RefuelingColumn {
  amount: Column;
  anotherCurrency: Column;
  assignedToRide: Column;
  attachments: Column;
  averageConsumption: Column;
  averageFuelConsCan: Column;
  billId: Column;
  createdAt: Column;
  createdBy: Column;
  currencyId: Column;
  customerId: Column;
  fuelConsCan: Column;
  fuelLevelCan: Column;
  fuelLevelUser: Column;
  fuelTypeId: Column;
  gasStationNetworkId: Column;
  id: Column;
  identifier: Column;
  licenceNumber: Column;
  locked: Column;
  mileage: Column;
  mileageDiffKm: Column;
  modifiedAt: Column;
  modifiedBy: Column;
  note: Column;
  price: Column;
  priceIncVat: Column;
  rideId: Column;
  source: Column;
  theoreticalConsumption: Column;
  timestamp: Column;
  unitPrice: Column;
  unitPriceIncVat: Column;
  vat: Column;
  vatPrice: Column;
  vehicleId: Column;
  vehicleName: Column;
}

interface Column {
  filter: null | Filter;
  name: string;
  required: boolean;
  searchable: boolean;
  sortable: boolean;
  system: boolean;
  title: string;
  type: string;
  visible: boolean;
}

export interface CurrencyIdApiResponse {
  currency: {
    id: number;
    name: string;
    code: string;
  };
}

export interface VatApiResponse {
  defaultVat: number;
}

export const RefuelingsTableSettingsKeys = {
  locked: 'table_list.columns.locked',
  accountingTs: 'table_list.columns.refuelings.timestamp',
  customer: 'table_list.columns.customerId',
  licenceNumber: 'table_list.columns.canRefuelings.licenceNumber',
  vehicleName: 'table_list.columns.canRefuelings.vehicleName',
  assignedToRide: 'table_list.columns.refuelings.assignedToRide',
  gasStationNetwork: 'table_list.columns.gasStationNetworkId',
  fuelType: 'table_list.columns.refuelings.fuelTypeId',
  amount: 'table_list.columns.refuelings.amount',
  vat: 'table_list.columns.refuelings.vat',
  unitPriceIncVat: 'table_list.columns.refuelings.unitPriceIncVat',
  unitPrice: 'table_list.columns.refuelings.unitPrice',
  price: 'table_list.columns.refuelings.price',
  vatPrice: 'table_list.columns.refuelings.vatPrice',
  priceIncVat: 'table_list.columns.refuelings.priceIncVat',
  currency: 'costsOverviewForm.currency',
  bill: 'table_list.columns.billId',
  note: 'table_list.columns.refuelings.note',
  attachments: 'table_list.columns.attachments',
  source: 'table_list.columns.refuelings.source',
  mileage: 'table_list.columns.refuelings.mileage',
  averageConsumption: 'table_list.columns.refuelings.averageConsumption',
  createdBy: 'table_list.columns.createdBy',
  createdAt: 'table_list.columns.createdAt',
  anotherCurrency: 'table_list.columns.refuelings.anotherCurrency',
  modifiedBy: 'table_list.columns.modifiedBy',
  modifiedAt: 'table_list.columns.modifiedAt',
  mileageDiffKm: 'table_list.columns.refuelings.mileageDiffKm',
};

export interface IAttachment {
  mimeType: string;
  name: string;
  path: string;
  size: number;
}

export type RefuelingsRecord = {
  id: string;
  vehicleId: number;
  accountingTs: string;
  amount: string;
  vat: string;
  unitPriceIncVat: string;
  price: string;
  priceIncVat: string;
  note: string;
  attachments: IAttachment[];
  anotherCurrency: boolean;
  assignedToRide: {
    link: string | null;
    value: string | null;
  };
  averageConsumption: string;
  averageFuelConsCan: string;
  bill: string | null;
  createdAt: string | null;
  createdBy: { id: number; name: string } | null;
  currency: string;
  customer: { id: number; label: string; name: string };
  fuelConsCan: string | null;
  fuelLevelCan: string | null;
  fuelLevelUser: string | null;
  fuelType: string | null;
  gasStationNetwork: string | null;
  identifier: string | null;
  licenceNumber: string | null;
  locked: string;
  mileage: string | null;
  modifiedAt: string | null;
  modifiedBy: { id: number; name: string } | null;
  rideId: string;
  source: string;
  theoreticalConsumption: string;
  unitPrice: string;
  vatPrice: string;
  vehicleName: string;
  mileageDiffKm: string | null;
};

export type RefuelingSummariesCell = {
  name: string;
  value: string[] | string;
};

export type RefuelingSummaries = {
  title: string;
  cells: RefuelingSummariesCell[];
};

export type RefuelingsResponse = {
  count: number;
  records: RefuelingsRecord[];
  summaries: RefuelingSummaries[];
};
